export const DMS_MODULE = 'Sklady';
export const CRUMB_LABEL_EDIT = 'edtPRInvoice';
export const NAME = 'PRInvoice';
export const RPZV_LOG = 'RpzvLog';
export const CRUMB_LABEL_KEY = 'PRINVOICE';
export const SELECTNAME = 'PrInvoice';
export const POLOZKY = 'Polozky';
export const TEXT = 'TEXT';
export const CAS_JDN_POC = 'CAS_JDN_POC';
export const CENA_ODHAD = 'CENA_ODHAD';
export const PP_NR = 'PP_NR';
export const GRNITEMS = 'GRNItems';
export const LOCALSTORAGE_STATE_KEY = 'DMS3_STATE';
export const PR_INVOICE = 'PRInvoice';
export const ND_NR = 'ND_NR';
export const DEPENDENT_TABLES = <const>[
	POLOZKY,
	RPZV_LOG,
	GRNITEMS,
	PR_INVOICE,
];
export const POLOZKY_COLS = {
	TEXT,
	CAS_JDN_POC,
	CENA_ODHAD,
	PP_NR,
};
export enum TRANSACTION_TYPE {
	FULL_PAYMENT = 1,
	PARTIAL_PAYMENT = 2
}

export type DependentTableNames = typeof DEPENDENT_TABLES[number];

export enum TAB_NAMES {
	HLAVNI = 'hlavni',
}

export const TABS = {
	[TAB_NAMES.HLAVNI]: { id: TAB_NAMES.HLAVNI, labelKey: 'tsPROrders' },
};

export const GRID_COLUMNS = {
	ND_NR,
};
